/**
 * 14-E-2 — EVER TV 영상 ID 정규화.
 *
 * YouTube 영상은 본문 RichTextEditor(TipTap, iframe/embed 노드 없음)가 아니라 전용
 * youtubeId 필드로만 받는다. storefront 는 youtubeId 로 youtube-nocookie iframe 을 직접
 * 구성해 allowlist 도메인만 렌더하므로, 본문에 외부 스크립트/임베드를 직접 넣지 않는 것이
 * XSS 측면에서 안전하다.
 *
 * 운영자가 11자 영상 ID(예: dQw4w9WgXcQ) 또는 youtube 공유/시청 URL 둘 다 붙여넣을 수
 * 있으므로, URL 이면 영상 ID 만 추출해 저장한다(be-catalog 계약: youtubeId 는 영상 ID
 * 문자열, @Size max 32).
 */

/** 표준 YouTube 영상 ID: 영문/숫자/하이픈/언더스코어 11자. */
export const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

/**
 * 입력 문자열에서 YouTube 영상 ID 를 추출한다.
 * - 이미 11자 ID 면 그대로 반환.
 * - watch?v= / youtu.be/ / /embed/ / /shorts/ URL 이면 그 안의 ID 를 추출.
 * - 어디에도 맞지 않으면 trim 한 원문을 그대로 반환(BE @Size(max=32) 검증에 위임).
 * - 빈 문자열/공백은 빈 문자열로 정규화.
 */
export const extractYoutubeId = (raw: string): string => {
  const value = raw.trim();
  if (value === '') return '';
  if (YOUTUBE_ID_PATTERN.test(value)) return value;
  const watch = /[?&]v=([A-Za-z0-9_-]{11})/.exec(value);
  if (watch?.[1]) return watch[1];
  const path = /(?:youtu\.be\/|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{11})/.exec(value);
  if (path?.[1]) return path[1];
  return value;
};
